export default interface IFlightResponse {
  id: "string";
  airlineId: "string";
  departurePlace: "string";
  diversionDecisionStatus: DiversionDecisionStatus;
  roomId: string;
  captain: string;
  internetStatus: boolean;
  planeLandedStatus: boolean;
  createdAt: string;
}

export enum DiversionDecisionStatus {
  DECISION_REQUIRED = "DECISION_REQUIRED",
  DECISION_NOT_REQUIRED = "DECISION_NOT_REQUIRED",
  DIVERSION_REQUIRED = "DIVERSION_REQUIRED",
  DIVERSION_NOT_REQUIRED = "DIVERSION_NOT_REQUIRED",
}
